import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { deleteMetricSessionStorage } from '../../../features/metric/metricSlice'
import { appendModel, modifyModelAttr } from '../../../features/site/siteSlice'
import { updateSite } from '../../utils/Organizations'

const INITIAL_STATE = {
    disableSubmit: false
}

function BudgetsAndThresholds(){
    const dispatch = useDispatch()
    const [state, setState] = useState(INITIAL_STATE)

    const trialMode = useSelector(state => state.session.trialMode)
    const model = useSelector(state => state.site.model)

    useEffect(() => {
        return () => {
            setState(INITIAL_STATE)
        }
    }, [])

    const save = async() => {
        setState(prev => ({
            ...prev,
            disableSubmit: true
        }))

        await updateSite(model.siteForm?.siteId, null, {
            site: model.siteForm
        })

        let all = [...model.all]
        let sites = [...model.sites]
        
        const allIdx = model.all.findIndex(s => s.siteId === model.siteForm.siteId)

        all[allIdx] = {
            ...model.siteForm
        }
        sites[model.siteActiveIdx] = {
            ...model.siteForm
        }

        await dispatch(appendModel({
            all,
            sites
        }))

        toast.success("Update successful", {containerId: "defaultToastContainer"})

        setState(prev => ({
            ...prev,
            disableSubmit: false
        }))
    }

    const onChange = (property="dailyBudgets") => (e) => {
        let modelCopy = {siteForm:{...model.siteForm}}

        if(property){
            modelCopy.siteForm.attr = {
                ...modelCopy.siteForm.attr,
                [property]: {
                    ...(modelCopy?.siteForm?.attr[property] ?? {}),
                    [e.target.name]: e.target.value
                }
            }
        } else {
            modelCopy.siteForm.attr[e.target.name] = e.target.value
        }

        dispatch(modifyModelAttr({
            key: "siteForm",
            body: modelCopy.siteForm
        }))
    }

    const { disableSubmit } = state

    const { siteForm } = model

    const inputDisabled = model.reseller && model.isAffiliate

    return <>
        <h3>Daily Budgets and Thresholds</h3><br />
        {!trialMode && <>
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className="d-flex flex-row-reverse">
                <div>
                    <div className="mr-2">
                        <button className="btn btn-lg btn-primary" disabled={disableSubmit} onClick={() => save()}>
                            <i class="fas fa-save"></i> Save
                        </button>
                    </div>
                </div>
            </div>}    
        
            <div className="form-row">
                <div class="form-group col-xl-4 col-lg-6 col-md-6 col-sm-12">
                    <label class="col-form-label">Google Ads Budget:</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                        </div>
                        <input type="number" class="form-control" name="ga" value={siteForm?.attr?.dailyBudgets?.ga} onChange={onChange()} disabled={disableSubmit} />
                    </div>
                </div>
                <div class="form-group col-xl-4 col-lg-6 col-md-6 col-sm-12">
                    <label class="col-form-label">FB Ads Budget:</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                        </div>
                        <input type="number" class="form-control" name="fb" value={siteForm?.attr?.dailyBudgets?.fb} onChange={onChange()} disabled={disableSubmit} />
                    </div>
                </div>
                <div class="form-group col-xl-4 col-lg-6 col-md-6 col-sm-12">
                    <label class="col-form-label">MS Ads Budget:</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                        </div>
                        <input type="number" class="form-control" name="bing" value={siteForm?.attr?.dailyBudgets?.bing} onChange={onChange()} disabled={disableSubmit} />
                    </div>
                </div>
            </div>
            
            <div className="form-row d-flex justify-content-center">
                <div class="form-group col-xl-4 col-lg-6 col-md-6 col-sm-12">
                    <label class="col-form-label">LinkedIn Ads Budget:</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                        </div>
                        <input type="number" class="form-control" name="linkedin" value={siteForm?.attr?.dailyBudgets?.linkedin} onChange={onChange()} disabled={disableSubmit} />
                    </div>
                </div>
                {siteForm?.attr?.isEcommerce && <div class="form-group col-xl-4 col-lg-6 col-md-6 col-sm-12">
                    <label class="col-form-label">ROAS Threshold:</label>
                    <input type="number" step="0.1" class="form-control" placeholder="1.5" name="roasThreshold" value={siteForm?.attr?.roasThreshold} onChange={onChange(null)} disabled={disableSubmit} />
                </div>}
            </div>
        </>}
    </>
}

export default BudgetsAndThresholds